import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function EmpresasAseguradoras() {

    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

    },[]);

    return (
        
        <div className="hold-transition">
            <Header />
            <Aside activelink="settings" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div class="col-sm-8">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li class="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li class="breadcrumb-item">Administrador de EPS y Aseguradoras</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Administrador de EPS y Aseguradoras</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="content" >
                    <div class="container-fluid">

                        
                        <div class="row">
                            <div class="col-md-12 btn-settings-container">
                                
                                <Link to="/aseguradoras" class="btn-settings">
                                EPS / Aseguradoras
                                </Link>

                            </div>          
                        </div>

                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
        
    );
}
export default EmpresasAseguradoras;